// extracted by mini-css-extract-plugin
export default {"outer":"sCN9H","wrapper":"dsC03","content":"G9FS9","button":"DbUTC"};